var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompareRightStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 913 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "98.963%",
    y2: "50%",
    id: "compare-right-stars_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.678,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "98.963%",
    y2: "50%",
    id: "compare-right-stars_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.678,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "compare-right-stars_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487FCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "129.061%",
    y2: "50%",
    id: "compare-right-stars_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081122",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487FCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "compare-right-stars_svg__e"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#compare-right-stars_svg__a)",
    opacity: 0.542,
    x: 824,
    y: 412,
    width: 89,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#compare-right-stars_svg__b)",
    opacity: 0.542,
    y: 92,
    width: 375,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#compare-right-stars_svg__c)",
    opacity: 0.542,
    x: 659,
    y: 505,
    width: 164,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.5 0C464.27 0 473 8.73 473 19.5S464.27 39 453.5 39h-42c-10.77 0-19.5-8.73-19.5-19.5S400.73 0 411.5 0h42zm0 3h-42c-9.113 0-16.5 7.387-16.5 16.5 0 9.005 7.215 16.326 16.18 16.497l.32.003h42c9.113 0 16.5-7.387 16.5-16.5 0-9.005-7.215-16.326-16.18-16.497L453.5 3z",
    fill: "#3C5475",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#compare-right-stars_svg__d)",
    opacity: 0.752,
    y: 9,
    width: 458,
    height: 21,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#80AFE5",
    filter: "url(#compare-right-stars_svg__e)",
    cx: 448,
    cy: 19,
    r: 10
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgCompareRightStars as ReactComponent };